<template>
  <van-sticky :offset-top="0">
  <van-button type="primary" @click="goBack">返回列表</van-button>
</van-sticky>
  <van-notice-bar
    wrapable
    :scrollable="false"
    color="#484848"
    background="#F1F1F1"
    left-icon="records"
  >
    <p class="text3Indentation">
      本结果核心是基于北京友谊医院、安贞医院的顶级专家经验，充分依据《中国心血管病一级预防指南》和美国国家心肺和血液研究所的MESA指南！
      可以较为全面、科学、真实的反映个人心脏当前的风险状态。注：风险只是一种状态反映，科学的应对和良好的心态更为重要!
    </p>
  </van-notice-bar>
  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853' }"
    content-position="center"
    >基础信息</van-divider
  >
  <van-cell-group inset>
    <van-field label="姓名" v-model="userInfo.realName" readonly />
    <van-field label="电话" v-model="userInfo.phone" readonly />
    <van-field v-model="userInfo.hospitalName" label="体检机构" readonly />
    <van-field label="年龄" v-model="userInfo.age" readonly />
    <van-field v-model="userInfo.gender" label="性别" readonly />
  </van-cell-group>
  <br />
  <van-cell-group inset>
    <van-field label="订单编号" v-model="orderPlanVo.orderId" readonly />
    <van-field label="分析计算时间" v-model="orderPlanVo.createTime" readonly />
  </van-cell-group>
  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853' }"
    content-position="center"
    >分析结果</van-divider
  >
  <p>基于您的当前数据，我们分析您的心脏风险情况为：</p>
  <div class="about" id="level"></div>
  <div>
    <van-tag type="warning" size="large">{{
      userRiskLevel.userRisk.riskMessgae
    }}</van-tag>
  </div>
  <br />
  <p class="text3Indentation">
    <van-notice-bar color="#a0a0a0" background="#ffffff" left-icon="guide-o">
      风险等级A，风险极低用户，继续保持现有状态
    </van-notice-bar>
    <van-notice-bar
      wrapable
      :scrollable="false"
      color="#a0a0a0"
      background="#ffffff"
      left-icon="guide-o"
    >
      风险等级B，风险低危用户，需要注意一些潜在的风险习惯
    </van-notice-bar>
    <van-notice-bar
      wrapable
      :scrollable="false"
      color="#a0a0a0"
      background="#ffffff"
      left-icon="guide-o"
    >
      风险等级C，风险中危用户，积极应对，调整不好的习惯
    </van-notice-bar>
    <van-notice-bar
      wrapable
      :scrollable="false"
      color="#a0a0a0"
      background="#ffffff"
      left-icon="guide-o"
    >
      风险等级D，风险高危用户，平时要注意身体变化，可以考虑去门诊进一步检查
    </van-notice-bar>
  </p>
  <br />
  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853' }"
    content-position="center"
    dashed
    >钙化积分</van-divider
  >
  <div>
    钙化积分：<van-button plain type="danger"
      >{{ userRiskLevel.userRisk.cacs }}分</van-button
    >
    <br />
    <br /><van-tag type="warning" size="large"
      >属于{{ userRiskLevel.userRisk.cacsLevel }}风险</van-tag
    >
  </div>
  <van-notice-bar
    wrapable
    :scrollable="false"
    left-icon="info-o"
    color="#484848"
    background="#F1F1F1"
  >
    <p class="text3Indentation">
      此部分是通过您的胸部CT影像数据计算得出。通对斑块的计算，可以较为客观的反映心脏血管的实际风险。
    </p>
    <p class="text3Indentation">
      美国MESA通过长达10年的、近10000名用户的跟踪，该因素已经被认为具有极强的心脏健康指导意义。并被国内外顶级医疗机构纳入健康筛查和临床检查，包括国内的安贞医院、协和医院。
    </p>
    <p class="text3Indentation">
      冠状动脉钙化与冠心病存在相关关系，冠状动脉钙化是冠状动脉粥样硬化的特异性标志，冠状动脉钙化积分对发现冠状动脉粥样硬化，了解斑块分布、斑块负荷及冠心病的筛查有重要的临床意义。标准如下:
    </p>
  </van-notice-bar>
  <van-cell-group inset>
    <van-field label="0" model-value="风险极低" readonly />
    <van-field label="1～100" model-value="低危风险" readonly />
    <van-field label="101～400" model-value="中危风险" readonly />
    <van-field label="400以上" model-value="高危风险" readonly />
  </van-cell-group>
  <br />
  <van-notice-bar wrapable :scrollable="false" left-icon="info-o">
    <p class="text2Indentation">
      特别说明：钙化积分只是一定程度上反映心脏血管斑块情况，受CT设备等因素影响，存在一定误差，此结果数值仅供参考。
    </p>
  </van-notice-bar>
  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853' }"
    content-position="center"
    dashed
    >风险问题详单</van-divider
  >
  <van-tag color="#ffe1e1" text-color="#ad0000">风险提示</van-tag>
  <div class="about" id="risk"></div>
  <!--van-tag type="danger">高风险0条</van-tag-->
  <div>
    <van-tag round type="warning" size="large">中危以上(含中危)风险</van-tag>
  </div>
  <br />
  <van-notice-bar
    v-for="(personRiskManager, id) in personRiskManagerList.personRiskManager"
    :key="id"
    wrapable
    :scrollable="false"
    background="#ffffff"
    left-icon="warn-o"
  >
    <p class="text3Indentation">{{ personRiskManager.healthRulesMessage }}</p>
  </van-notice-bar>
  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853' }"
    content-position="center"
    >根据您的情况，我们调理建议如下:</van-divider
  >
  <van-tag color="#ffe1e1" text-color="#ad0000">
    <audio
      :src="userOrderCard.orderPlanVo.audioSrc"
      ref="audio"
      @pause="onPause"
      @play="onPlay"
      @timeupdate="onTimeupdate"
      @canplay="onLoadedmetadata"
      controls
    ></audio
  ></van-tag>

  <div class="van-hairline--surround">
    <van-notice-bar
      wrapable
      :scrollable="false"
      color="#a0a0a0"
      background="#ffffff"
    >
      <p class="text3Indentation" style="white-space: pre-wrap">
        {{ userOrderCard.orderPlanVo.aiDesc }}
      </p>
    </van-notice-bar>
  </div>
  <van-notice-bar wrapable :scrollable="false" left-icon="info-o">
    <p class="text2Indentation">
      特别说明：本分析结果非诊疗推断。受限于检查数据的准确性、时效性，以及健康检查技术的局限性，此分析在已知范围存在误差。
    </p>
  </van-notice-bar>

  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853' }"
    content-position="center"
    >全国区域分析</van-divider
  >
  <div class="van-hairline--surround">
    <van-cell-group inset>
      <van-divider
        :style="{ color: '#EA6853', borderColor: '#EA6853' }"
        content-position="center"
        dashed
        ><p class="text3Indentation">
          心血管病的人群风险存在显著的地区差异，而导致各地人群风险的主要危险因素也并不相同:
        </p></van-divider
      >
      <van-notice-bar
        wrapable
        :scrollable="false"
        color="#a0a0a0"
        background="#ffffff"
        left-icon="aim"
      >
        <p class="text3Indentation">
          1. 东北地区受副食因素（水果蔬菜摄入不足、红肉摄入过多）影响最大
        </p>
      </van-notice-bar>
      <van-notice-bar
        wrapable
        :scrollable="false"
        color="#a0a0a0"
        background="ff5330"
        left-icon="warning"
      >
        <p class="text3Indentation">
          2. 华北、西北地区受肥胖因素和血压因素影响较大
        </p>
      </van-notice-bar>
      <van-notice-bar
        wrapable
        :scrollable="false"
        color="#a0a0a0"
        background="#ffffff"
        left-icon="aim"
      >
        <p class="text3Indentation">3. 华东、西南地区受吸烟和饮酒因素较大</p>
      </van-notice-bar>
      <van-notice-bar
        wrapable
        :scrollable="false"
        color="#a0a0a0"
        background="#ffffff"
        left-icon="aim"
      >
        <p class="text3Indentation">
          4. 华南地区受粗粮摄入与运动不足因素影响较大
        </p>
      </van-notice-bar>
      <van-image
        src="https://ailyway-img-1258265833.cos.ap-shanghai.myqcloud.com/xinxueguan.png"
      />
    </van-cell-group>
  </div>
  <van-floating-panel v-model:height="height" :anchors="anchors">
    <div style="text-align: center; padding: 15px">
      <p>小结记录</p>
      <van-form @submit="onSubmit">
        <van-cell-group inset>
          <van-field
            v-model="doctorSummary.three"
            rows="5"
            autosize
            required
            label="小结记录"
            type="textarea"
            maxlength="300"
            placeholder="请输入留言"
            :rules="[{ required: true, message: '小结不能为空' }]"
            show-word-limit
          />
          <van-field
            required
            label="预约下次时间"
            v-model="doctorSummary.nextTime"
            @click="show = true"
            placeholder="请选择下次见面时间"
          />
          <van-calendar v-model:show="show" @confirm="onConfirm" />
        </van-cell-group>
        <div style="margin: 16px">
          <van-button
            round
            block
            type="primary"
            native-type="submit"
            @click="getData"
          >
            提交
          </van-button>
          <br />
          <br />
          <van-button round block type="success" url="https://github.com"
            >历史小结查询</van-button
          >
        </div>
      </van-form>
    </div>
  </van-floating-panel>
</template>

<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import * as echarts from "echarts";
import request from "../../utils/request";
import NProgress from "nprogress";
import { postDoctorSummary } from "../../api/doctor";
import "nprogress/nprogress.css";
import { useRouter } from "vue-router";
import { postUserLog } from "../../api/userlog";
import { showDialog } from 'vant';
NProgress.start();
// 给页面设置请求加载进度条效果
window.onload = function () {
  NProgress.done();
};

export default {
  setup() {
    const router = useRouter();
    const bingingNotice = ref("");
    const showOverlay = ref(false);
    const showBinging = ref(false);
    const goToUserInfo = ref(false);
    const goToAbout = ref(false);
    const productAction = ref(2);
    const anchors = [80, Math.round(0.7 * window.innerHeight)];
    const height = ref(anchors[0]);
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    
    const userRiskLevel = reactive({
      userRisk: {
        riskLevel: "",
        cacs: "",
        cacsLevel: "",
        riskMessgae: "",
        highRisk: "",
        mediumRisk: "",
        lowRisk: "",
        veryLowRisk: "",
      },
    });
    const personRiskManagerList = reactive({
      personRiskManager: {
        personId: "",
        healthRulesId: "",
        healthRulesMessage: "",
        healthResults: "",
        resultsMessage: "",
      },
    });
    const userOrderCard = reactive({
      orderPlanVo: {
        wxOpenId: "",
        orderId: "",
        orderPlanId: "",
        aiDesc: "",
        audioSrc: "",
        createTime: "",
      },
    });
    const state = reactive({
      userInfo: {
        hospitalName: "",
        realName: "",
        phone: "",
        age: "",
        gender: "",
      },
    });
    const doctorSum = reactive({
      doctorSummary: {
        three: "",
        nextTime: "",
        wxOpenID: "",
      },
    });
    const show = ref(false);

    const formatDate = (date) =>
      `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    const onConfirm = (value) => {
      show.value = false;
      doctorSum.doctorSummary.nextTime = formatDate(value);
    };
    const getData = () => {
      doctorSum.doctorSummary.wxOpenID =
        router.currentRoute.value.params.wxOpenId;
      postDoctorSummary(doctorSum.doctorSummary).then((res) => {
        if (res.data.code == 0) {
          showDialog({
            title: "提交成功",
            message:
              "数据保存成功",
            theme: "round-button",
          }).then(() => {
            
          });
        } else {
          showDialog({
            title: "提交异常",
            message:
              "网络原因，导致提交失败，请稍后重试",
            theme: "round-button",
          }).then(() => {
            
          });
        }
      });
    };
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      request
        .get("/wxmanager/doctor/riskLevel", {
          params: {
            personId: router.currentRoute.value.params.wxOpenId,
          },
        })
        .then((res2) => {
          userRiskLevel.userRisk = res2.data.data;
          console.log("风险级别==>" + userRiskLevel.userRisk);
          levelInit();
          riskInfo();
        });
      request
        .get("/wxmanager/doctor/riskManager", {
          params: {
            personId: router.currentRoute.value.params.wxOpenId,
          },
        })
        .then((res3) => {
          personRiskManagerList.personRiskManager = res3.data.data;
          console.log("风险详单==>" + personRiskManagerList);
        });

      request
        .get("/wxmanager/doctor/userinfo", {
          params: {
            personId: router.currentRoute.value.params.wxOpenId,
          },
        })
        .then((res1) => {
          console.log(res1.data.data);
          state.userInfo = res1.data.data;
        });
    });

    request
      .get("/wxmanager/doctor/findUserOrderCard", {
        params: {
          personId: router.currentRoute.value.params.wxOpenId,
        },
      })
      .then((res) => {
        console.log(res.data.data);
        userOrderCard.orderPlanVo = res.data.data;
      });
    function goBack(){
      router.go(-1);
    }
    function levelInit() {
      var myChart = echarts.init(document.getElementById("level"));
      console.log(userRiskLevel.userRisk.riskLevel);
      myChart.setOption({
        tooltip: {},
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", "75%"],
            radius: "90%",
            min: 0,
            max: 1,
            splitNumber: 8,
            axisLine: {
              lineStyle: {
                width: 6,
                color: [
                  [0.25, "#4169e1"],
                  [0.5, "#4ad187"],
                  [0.75, "#FDDD60"],
                  [1, "#FF6E76"],
                ],
              },
            },
            pointer: {
              icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
              length: "12%",
              width: 20,
              offsetCenter: [0, "-60%"],
              itemStyle: {
                color: "inherit",
              },
            },
            axisTick: {
              length: 12,
              lineStyle: {
                color: "inherit",
                width: 2,
              },
            },
            splitLine: {
              length: 20,
              lineStyle: {
                color: "inherit",
                width: 5,
              },
            },
            axisLabel: {
              color: "#464646",
              fontSize: 20,
              distance: -60,
              rotate: "tangential",
              formatter: function (value) {
                if (value === 0.875) {
                  return "D";
                } else if (value === 0.625) {
                  return "C";
                } else if (value === 0.375) {
                  return "B";
                } else if (value === 0.125) {
                  return "A";
                }
                return "";
              },
            },
            title: {
              offsetCenter: [0, "-10%"],
              fontSize: 20,
            },
            detail: {
              fontSize: 30,
              offsetCenter: [0, "-35%"],
              valueAnimation: true,
              formatter: function (value) {
                if (
                  Math.round(value * 100) > 75 &&
                  Math.round(value * 100) < 101
                ) {
                  return "高危";
                } else if (
                  Math.round(value * 100) > 50 &&
                  Math.round(value * 100) < 76
                ) {
                  return "中危";
                } else if (
                  Math.round(value * 100) > 25 &&
                  Math.round(value * 100) < 51
                ) {
                  return "低微";
                } else {
                  return "极低风险";
                }
              },
              color: "inherit",
            },
            data: [
              {
                value: userRiskLevel.userRisk.riskLevel,
                name: "风险情况",
              },
            ],
          },
        ],
      });
    }
    function riskInfo() {
      var myChartRisk = echarts.init(document.getElementById("risk"));
      myChartRisk.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "风险因素识别分析",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: userRiskLevel.userRisk.veryLowRisk,
                name: "极低风险因素",
              },
              { value: userRiskLevel.userRisk.lowRisk, name: "低风险因素" },
              { value: userRiskLevel.userRisk.mediumRisk, name: "中风险因素" },
              { value: userRiskLevel.userRisk.highRisk, name: "高风险因素" },
            ],
          },
        ],
      });
    }
    return {
      ref,
      getData,
      userRiskLevel,
      productAction,
      anchors,
      height,
      showOverlay,
      showBinging,
      bingingNotice,
      goToUserInfo,
      goToAbout,
      personRiskManagerList,
      userOrderCard,
      show,
      goBack,
      onConfirm,
      ...toRefs(state),
      ...toRefs(doctorSum),
      ...toRefs(userOrderCard),
    };
  },
};
</script>
<style lang="less" scoped>
#level {
  height: 400px;
  width: 100%;
}

#risk {
  height: 400px;
  width: 100%;
}

.van-cell {
  border-radius: 30rpx;
  margin: 40rpx 0 0 0;
}

/* 去除单元格cell下边框 */
.van-cell:after {
  border-bottom: none !important;
  border-bottom-style: none !important;
}

/* 单元格标题title */
.van-cell .van-cell__title {
  color: #7186e1;
}

/* 标题下方label */
.van-cell .van-cell__label {
  color: #000;
  font-weight: 500;
}

.textIndentation {
  font-size: 12px;
  text-align: left;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 500px;
  height: 400px;
}

.text3Indentation {
  text-align: left;
  font-weight: bold;
  font-size: 14px;
}

.text2Indentation {
  text-align: left;
  font-size: 12px;
}

.content {
  padding: 16px 16px 160px;
}
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
.video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video-container {
  position: relative;
  width: 95%;
  clear: both;
  margin: 0 auto;
}
</style>
